import React, { useState } from 'react'
import FontIcon from '../../common/FontIcon'
import { Button } from '../../common/index'
import StarRating from '../super-admin/companies/coupons/manage/StarRating'
import CouponDetailsModal from './CouponDetailsModal'
import CouponCodePreview from './CouponCodePreview'

const { REACT_APP_IMAGE_BASE_URL } = process.env;

function CompanyModalCoupon({ coupon, booklet, userOwnsBooklet, isReview = true }) {
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const showAmount = userOwnsBooklet && coupon.availableByUser !== null && coupon?.availableByUser !== undefined && coupon.availableByUser > 1;

  // Show booklet color for assessment section background if booklet has color
  const showBookletColor = Boolean(booklet?.colorLeft || booklet?.colorRight);
  const bookletColor = booklet?.colorLeft || booklet?.colorRight;

  // Convert hex to rgba with opacity
  const hexToRgba = (hex, opacity) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  };

  const assessmentBgColor = showBookletColor ? hexToRgba(bookletColor, 0.08) : 'rgba(221, 218, 216, 0.85)';
  const assessmentBorderColor = showBookletColor ? hexToRgba(bookletColor, 0.4) : 'rgba(0, 0, 0, 0.2)';

  const amtActivated = coupon.amount;

  return (
    <>
      <div className="flex flex-col">
        <div key={coupon._id} className="box booklet-company-coupon">
          <div className="coupon">
            <div className='details'>
              <h2>{coupon.discount}</h2>
              <p className="smallTitle">
                {`${showAmount ? `(${coupon?.availableByUser}) ` : ''}${coupon?.smallTitle}`}
              </p>
              <p style={{ color: '#222' }}>{coupon?.description}</p>
              <p>{coupon?.terms}</p>
            </div>
            {coupon?.imageURL ? (
              <span><img src={REACT_APP_IMAGE_BASE_URL + coupon?.imageURL} alt={coupon?.smallTitle} /></span>
            ) : (
              <span className='font-icon'>
                <FontIcon iconText='tag' />
              </span>
            )}
          </div>
          {isReview ?
            <CouponCodePreview coupon={coupon} />
            : (
              <div className="coupon-code-preview">
                <div className="flex flex-col coupon-code-preview-inner">
                  <p>Antal aktiverade kuponger</p>
                  <h4>{amtActivated}</h4>
                </div>
              </div>
            )
          }
        </div>
        {(isReview && coupon?.assessment && coupon.assessment.shouldShowAssessment) && (
          <div
            className="coupon-assessment-preview"
            style={{
              backgroundColor: assessmentBgColor,
              borderTop: 'none',
              borderLeft: `2px dashed ${assessmentBorderColor}`,
              borderRight: `2px dashed ${assessmentBorderColor}`,
              borderBottom: `2px dashed ${assessmentBorderColor}`,
            }}
          >
            {coupon.assessment.motivation && (
              <p className="assessment-preview-text">{coupon.assessment.motivation}</p>
            )}
            <div className="flex items-center justify-between">
              {coupon.assessment.rating !== undefined && coupon.assessment.rating !== null && (
                <div className="assessment-preview-rating">
                  <StarRating rating={coupon.assessment.rating} />
                </div>
              )}
              <Button
                type="button"
                className="primary sm"
                onClick={() => setIsDetailsModalOpen(true)}
              >
                Se detaljer
              </Button>
            </div>
          </div>
        )}
      </div>

      <CouponDetailsModal
        coupon={coupon}
        assessment={coupon?.assessment}
        isOpen={isDetailsModalOpen}
        onClose={() => setIsDetailsModalOpen(false)}
      />
    </>
  )
}

export default CompanyModalCoupon
